import axios from 'axios';
import router from '../router';

export default {
    prev: ({state, commit}) => {
        if (state.step === 1) {
            commit('initStep');
            router.push('/');

            return;
        }

        if (router.currentRoute._value.fullPath === `/${state.kitId}/overview`) {
            router.push(`/${state.kitId}`);
            return;
        }

        commit('prevStep');
    },

    next: ({state, commit, dispatch}) => {

        if (state.kitId && !state.step) {
            router.push(`/${state.kitId}`);
        }

        if (!state.step) {
            commit('nextStep');

            return;
        }

        if (router.currentRoute._value.path === `/${state.kitId}/overview`) {
            dispatch('goToWCCart');

            return;
        }
        
        if (state.step + 1 > state.current.groups.length) {

            router.push(`/${state.kitId}/overview`);

            return;
        };

        commit('nextStep');
    },

    saveCart: ({state}) => {

        let form_data = new FormData;
        form_data.append('action', 'save_kit_cart');
        form_data.append('user', kitBuilderData.uid);
        form_data.append('cart', JSON.stringify(state.cart));

        axios.post(siteData.ajaxUrl, form_data).catch(err => {
            console.error(err);
        });
    },

    addToCart: ({commit, dispatch}, {product, qtt, variation, attributes}) => {
        commit('addToCart', {product, qtt, variation, attributes});
        dispatch('saveCart');
    },

    removeFromCart: ({commit, dispatch}, {step, pid}) => {
        commit('removeFromCart', {step, pid});
        dispatch('saveCart');
    },

    updateCartItemQtt: ({commit, dispatch}, {step, pid, qtt}) => {
        commit('updateCartItemQtt', {step, pid, qtt});
        dispatch('saveCart');
    },

    goToWCCart: ({state}) => {
        let form_data = new FormData;
        form_data.append('action', 'go_to_cart');
        form_data.append('user', kitBuilderData.uid);
        form_data.append('kit', state.kitId);

        axios.post(siteData.ajaxUrl, form_data).then(res => {
            
            if (res.data.cart) {
                window.location.href = res.data.cart;
            }

        }).catch(err => {
            console.error(err);
        });
    },
}